'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["openAcademyToSoftwareModal", "selectedSoftware"];
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { openAcademyToSoftwareModal } from '../../actions/AcademyToSoftware';
import { EERIE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UsageTracker from '../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const BUTTON_MIN_WIDTH = 850;
const DisappearingUIIconButton = styled(UIIconButton).withConfig({
  displayName: "InfoButtonModalOpener__DisappearingUIIconButton",
  componentId: "sc-1yadzso-0"
})(["display:none !important;@media screen and (min-width:", "px){display:inline-block !important;}"], BUTTON_MIN_WIDTH);
const InfoButtonModalOpener = _ref => {
  let {
      openAcademyToSoftwareModal: openModal,
      selectedSoftware
    } = _ref,
    additionalProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const onClick = e => {
    e.stopPropagation();
    e.preventDefault();
    openModal('INFO_BUTTON', selectedSoftware);
    UsageTracker.track('interaction', {
      action: 'academy-to-software-button-clicked',
      whichButton: 'info'
    });
  };
  return /*#__PURE__*/_jsx(DisappearingUIIconButton, {
    "data-selected-software-icon": selectedSoftware,
    "data-test-id": "academy-to-software-desirability-info-icon-button",
    onClick: onClick,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.softwareDesirability.infoButton`
    }),
    use: "unstyled",
    children: /*#__PURE__*/_jsx(UIIcon, Object.assign({
      color: EERIE,
      name: "info",
      size: 24
    }, additionalProps))
  });
};
const mapDispatchToProps = dispatch => bindActionCreators({
  openAcademyToSoftwareModal
}, dispatch);
export default connect(null, mapDispatchToProps)(InfoButtonModalOpener);